// @flow

import { type FeatureName } from '@tectonics/prs/feature';
import { type PrsSupport } from './types';

export function hasSupportForFeature(prsSupport: PrsSupport, featureName: FeatureName): boolean {
  return prsSupport.features.some(feature => feature.name === featureName);
}
